import script from "./ParsleyProductsTab.vue?vue&type=script&setup=true&lang=js"
export * from "./ParsleyProductsTab.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import EmptyState from "@/components/neue/EmptyState.vue";
import InputField from "@/components/neue/InputField.vue";
import NeueLoading from "@/components/neue/NeueLoading.vue";
import NeueNumberedPagination from "@/components/neue/NeueNumberedPagination.vue";
import ParsleyProductRow from "@/components/parsley/ParsleyProductRow.vue";
import SegmentedControl from "@/components/neue/SegmentedControl.vue";
script.components = Object.assign({}, { EmptyState, InputField, NeueLoading, NeueNumberedPagination, ParsleyProductRow, SegmentedControl }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { EmptyState, InputField, NeueLoading, NeueNumberedPagination, ParsleyProductRow, SegmentedControl }, script.__o.components);}